
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return require("private-next-pages/home.js");
      }
    ]);
  